<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 col-12 md:col-12">
      <p-accordion [multiple]="false" (onOpen)="abrirTab($event.index)">
        <p-accordionTab header="{{'PRODUCTOSALERTA.LBL_ALERTA' | translate }}"
          [selected]="true">
          <!--Inyectar componente de alerta-->
          <app-producto-alerta
            [producto]="producto"
            [visualizar]="visualizar"
            [idProductoAlerta]="idProductoAlerta"
            (cancelar)="regresar()"
            (actualizarProductoAlerta)="recibirProductoAlerta($event)"></app-producto-alerta>
        </p-accordionTab>

        <p-accordionTab header="{{'PRODUCTOSALERTA.LBL_CONDICIONES' | translate }}"
          *ngIf="idProductoAlerta && (productoAlerta && !productoAlerta.indicadorNoAplica && productoAlerta.indicadorHabilitado)">
          <!--Inyectar componente de condiciones de alertas-->
          <app-producto-alerta-configuracion
            [producto]="producto"
            [visualizar]="visualizar"
            [productoAlerta]="productoAlerta"></app-producto-alerta-configuracion>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div class="grid form-footer-buttons" *ngIf="!procesando">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar()"
              pButton></button>
    </div>
  </div>
  <div class="grid" *ngIf="procesando">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>

</div>

